import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SaveButton from "../../../components/Buttons/SaveButton";
import FileUploadField from "../../../components/Fields/FileUploadField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import { useTranslations } from "../../../contexts/translationContext";
import FileCreateResultModel from "../../../models/FileCreateResultModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface IProps extends PopupProps {
    documentTemplateId: number
}

interface DocumentTemplateReviseModel {
    documentTemplateId: number
    fileName?: string
    file?: File
    fileResult?: FileCreateResultModel
}

const ReviseDocumentTemplatePopup: React.FC<IProps> = ({ show, onHide, documentTemplateId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<DocumentTemplateReviseModel>>({ isSuccesful: true, messages: [], data: undefined });
    const [file, setFile] = useState<File>();
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<DocumentTemplateReviseModel>({
        documentTemplateId: documentTemplateId,
    });

    function submit() {
        if (formData && file) {
            DataService
                .createFile(file)
                .then(fileResponse => {
                    handleResult(fileResponse);
                    if (fileResponse.isSuccesful === true && fileResponse.data) {
                        formData.fileResult = fileResponse.data;
                        DataService
                            .post<DataResult<DocumentTemplateReviseModel>>(`api/v1/DocumentTemplates/Revise`, formData)
                            .then(response => {
                                handleResult(response);
                                setServerErrors(response);
                                if (response.isSuccesful === true) {
                                    onHide();
                                }
                            })
                            .catch(e => handleException(e));
                    }
                    else {
                        handleResult(fileResponse);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string | File): void {
        if (name === 'fileName' && typeof (value) === 'object') {
            setFile(value);
            formData.fileName = value.name;
        }
        else {
            formData[name] = value;
        }
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'fileName', label: 'File', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Revise document template'} >
            <Popup.Body>
                <FileUploadField {...getFieldProps('fileName')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Revise' />
            </Popup.Footer>
        </Popup>
    );
}
export default ReviseDocumentTemplatePopup;